import api from "./api";

export function getBanks(page = 1, limit = 10, search = "") {
  return api.get(`/banks?page=${page}&limit=${limit}&search=${search}`);
}

export function getBankById(id) {
  return api.get(`/banks/${id}`);
}

export function createBank(data) {
  return api.post("/banks", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function updateBank(country_id, data) {
  return api.put(`/banks/${country_id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function deleteBank(id) {
  return api.delete(`/banks/${id}`);
}